import React from 'react';
import ReactECharts from 'echarts-for-react';

const BarChart = ({ item }) => {
  const { xaxis_values, yaxis_values } = item.data;

  const options = {
    title: {
      text: item.title,
      textStyle: {
        fontSize: 13,
      },
      left: 'center',
    },
    xAxis: {
      type: 'category',
      data: xaxis_values,
      name: item.xaxis_name,
      nameTextStyle: {
        fontSize: 12,
      },
      nameLocation: 'middle',
      nameGap: 30,
      axisLabel: {
        rotate: 0,
      },
    },
    yAxis: {
      type: 'value',
      name: item.yaxis_name,
      nameTextStyle: {
        fontSize: 12,
      },
      nameLocation: 'middle',
      nameGap: 60,
    },
    series: [
      {
        type: 'bar',
        data: yaxis_values,
        barGap: '30%',
        itemStyle: {
          color: '#3398DB', // Custom color
        },
      },
    ],
    grid: {
      containLabel: true,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
  };

  return (
    <ReactECharts
      option={options}
      style={{ width: '450px', height: '350px' }}
      opts={{ renderer: 'svg' }} // Use 'canvas' for better performance
    />
  );
};

export default BarChart;
